var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.917 163.459C323.917 256.891 243.978 331.752 148.806 323.338C65.0943 315.938 3 242.093 3 158.091V10.3995C3 6.33727 6.33684 3.14551 10.254 3.14551H167.521C254.134 5.32171 323.917 76.2659 323.917 163.604V163.459Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.815 216.701C270.815 245.282 247.747 268.35 219.166 268.35C190.586 268.35 167.518 245.282 167.518 216.701C167.518 245.282 144.45 268.35 115.869 268.35C87.2885 268.35 64.2207 245.282 64.2207 216.701C64.2207 188.121 87.2885 165.053 115.869 165.053C119.351 165.053 122.688 164.763 126.025 164.037C122.688 163.312 119.351 163.022 115.869 163.022C87.2885 163.022 64.2207 139.954 64.2207 111.373C64.2207 82.7924 87.2885 59.7246 115.869 59.7246C144.45 59.7246 167.518 82.7924 167.518 111.373C167.518 82.7924 190.586 59.7246 219.166 59.7246C247.747 59.7246 270.815 82.7924 270.815 111.373C270.815 139.954 247.747 163.022 219.166 163.022C215.684 163.022 212.348 163.312 209.011 164.037C212.348 164.763 215.684 165.053 219.166 165.053C247.747 165.053 270.815 188.121 270.815 216.701Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M316.518 3H10.399C6.31261 3 3 6.31269 3 10.3991V316.518C3 320.605 6.31261 323.917 10.399 323.917H316.518C320.605 323.917 323.917 320.605 323.917 316.518V10.3991C323.917 6.31269 320.605 3 316.518 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 167.975,
    cy: 164.074,
    r: 35,
    fill: "#CDD7D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwFree);
export default __webpack_public_path__ + "static/media/dfw-Free.7c0ebeb5b2b35c184103799407c6f9a7.svg";
export { ForwardRef as ReactComponent };